module.exports = __webpack_public_path__ + "static/img/gaozhongzhengzhi2.9e5978f8.jpg";